import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "govuk-heading-xl" }, "Results for", -1)
const _hoisted_2 = { class: "govuk-summary-list" }
const _hoisted_3 = { class: "govuk-summary-list__key" }
const _hoisted_4 = { class: "govuk-summary-list__value" }
const _hoisted_5 = {
  key: 0,
  class: "govuk-summary-list__actions"
}
const _hoisted_6 = ["href", "onClick"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Change")
const _hoisted_8 = { class: "govuk-visually-hidden" }
const _hoisted_9 = {
  key: 1,
  class: "govuk-summary-list__actions"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Change to previous year")
const _hoisted_12 = { class: "govuk-visually-hidden" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Change to following year")
const _hoisted_16 = { class: "govuk-visually-hidden" }
const _hoisted_17 = { class: "govuk-summary-list__key" }
const _hoisted_18 = { class: "govuk-summary-list__value" }
const _hoisted_19 = {
  key: 0,
  class: "govuk-summary-list__actions"
}
const _hoisted_20 = ["href", "onClick"]
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Change")
const _hoisted_22 = { class: "govuk-visually-hidden" }
const _hoisted_23 = {
  key: 1,
  class: "govuk-summary-list__actions"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Change to previous year")
const _hoisted_26 = { class: "govuk-visually-hidden" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Change to following year")
const _hoisted_30 = { class: "govuk-visually-hidden" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "Digital Search Results", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "govuk-inset-text" }, " These are available when a will, grant or probate was issued after 1st January 1996. When the documents were issued before 31st December 1995 they will show in the Image Search Results in the section lower down this page. Results for soldiers who died while serving in the British armed forces between 1850 and 1986 will all be shown as Digital Search Results. ", -1)
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "govuk-table__container" }
const _hoisted_35 = { class: "govuk-table" }
const _hoisted_36 = { class: "govuk-table__caption govuk-table__caption--m" }
const _hoisted_37 = { class: "govuk-table__head" }
const _hoisted_38 = { class: "govuk-table__row" }
const _hoisted_39 = ["aria-sort"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "govuk-table__header"
}, null, -1)
const _hoisted_42 = { class: "govuk-table__body" }
const _hoisted_43 = { class: "govuk-table__cell" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  "aria-live": "polite",
  role: "status",
  "aria-atomic": "true",
  class: "govuk-visually-hidden"
}
const _hoisted_47 = {
  key: 1,
  class: "moj-pagination",
  id: "pagination-label"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", {
  class: "govuk-visually-hidden",
  "aria-labelledby": "pagination-label"
}, "Pagination navigation", -1)
const _hoisted_49 = { class: "moj-pagination__list" }
const _hoisted_50 = { class: "moj-pagination__item moj-pagination__item--prev" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Previous")
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "govuk-visually-hidden" }, " set of pages", -1)
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 0,
  class: "moj-pagination__link",
  href: "#"
}
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "moj-pagination__item moj-pagination__item--next" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "govuk-visually-hidden" }, " set of pages", -1)
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = { class: "moj-pagination__results" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode("Showing ")
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" to ")
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" of ")
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" results")
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", { class: "govuk-body-m govuk-!-font-weight-bold govuk-!-padding-top-5" }, "Can't find what you are looking for? Try looking at the Image Search Results below. You can also look through each year using the 'Change to previous year' and 'Change to following year' links. Or try adding keywords to your search.", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "Image Search Results", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "govuk-inset-text" }, " These are available when a will, grant or probate was issued before 31st December 1995. When the documents were issued after 1st January 1996 they will show in the Digital Search Results in the section higher up this page. Results for soldiers who died while serving in the British armed forces between 1850 and 1986 will all be shown as Digital Search Results. ", -1)
const _hoisted_69 = { key: 2 }
const _hoisted_70 = { class: "govuk-body-l govuk-!-font-weight-bold" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "govuk-grid-row" }
const _hoisted_73 = { class: "govuk-grid-column-one-third" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = {
  key: 3,
  class: "moj-pagination",
  id: "pagination-label"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("p", {
  class: "govuk-visually-hidden",
  "aria-labelledby": "pagination-label"
}, "Pagination navigation", -1)
const _hoisted_77 = { class: "moj-pagination__list" }
const _hoisted_78 = { class: "moj-pagination__item moj-pagination__item--prev" }
const _hoisted_79 = /*#__PURE__*/_createTextVNode("Previous")
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "govuk-visually-hidden" }, " set of pages", -1)
const _hoisted_81 = [
  _hoisted_79,
  _hoisted_80
]
const _hoisted_82 = ["onClick"]
const _hoisted_83 = {
  key: 0,
  class: "moj-pagination__link",
  href: "#"
}
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { class: "moj-pagination__item moj-pagination__item--next" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_87 = /*#__PURE__*/_createElementVNode("span", { class: "govuk-visually-hidden" }, " set of pages", -1)
const _hoisted_88 = [
  _hoisted_86,
  _hoisted_87
]
const _hoisted_89 = { class: "moj-pagination__results" }
const _hoisted_90 = /*#__PURE__*/_createTextVNode("Showing ")
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" to ")
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" of ")
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" results")
const _hoisted_94 = /*#__PURE__*/_createElementVNode("p", { class: "govuk-body-m govuk-!-font-weight-bold govuk-!-padding-top-5" }, "Can't find what you are looking for? Try looking at the Digital Search Results above. You can also look through each year using the 'Change to previous year' and 'Change to following year' links. Or try adding keywords to your search.", -1)
const _hoisted_95 = ["href", "onClick"]
const _hoisted_96 = {
  key: 4,
  class: "fullscreen-pdf"
}
const _hoisted_97 = { class: "header" }
const _hoisted_98 = { class: "action-container" }
const _hoisted_99 = {
  key: 0,
  class: "form-container"
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "To order documents fill out the following fields using the information from the image exactly as it appears on the page", -1)
const _hoisted_101 = {
  key: 1,
  class: "pdf-container"
}
const _hoisted_102 = { class: "footer" }
const _hoisted_103 = { class: "action-container" }
const _hoisted_104 = {
  key: 0,
  class: "action-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_pdf = _resolveComponent("pdf")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("dl", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stage1Fields, (field, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: index,
          class: "govuk-summary-list__row"
        }, [
          _createElementVNode("dt", _hoisted_3, _toDisplayString(field.label), 1),
          _createElementVNode("dd", _hoisted_4, _toDisplayString(_ctx.getFormattedSummaryValue(field, _ctx.stageData)), 1),
          (!_ctx.isYearField(field))
            ? (_openBlock(), _createElementBlock("dd", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: { name: 'Home', hash: '#' + field.name + '-field-group' },
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate }) => [
                    _createElementVNode("a", {
                      class: "govuk-link",
                      href: href,
                      onClick: navigate
                    }, [
                      _hoisted_7,
                      _createElementVNode("span", _hoisted_8, _toDisplayString(field.label), 1)
                    ], 8, _hoisted_6)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            : (_openBlock(), _createElementBlock("dd", _hoisted_9, [
                _createElementVNode("a", {
                  class: "govuk-link",
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.prevYear(field)), ["prevent"])
                }, [
                  _hoisted_11,
                  _createElementVNode("span", _hoisted_12, _toDisplayString(field.label), 1)
                ], 8, _hoisted_10),
                _hoisted_13,
                _createElementVNode("a", {
                  class: "govuk-link",
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.nextYear(field)), ["prevent"])
                }, [
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(field.label), 1)
                ], 8, _hoisted_14)
              ]))
        ], 512)), [
          [_vShow, _ctx.showSummaryField(field, _ctx.stageData)]
        ])
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stage2Fields, (field, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: index,
          class: "govuk-summary-list__row"
        }, [
          _createElementVNode("dt", _hoisted_17, _toDisplayString(field.label), 1),
          _createElementVNode("dd", _hoisted_18, _toDisplayString(_ctx.getFormattedSummaryValue(field, _ctx.stageData)), 1),
          (!_ctx.isYearField(field))
            ? (_openBlock(), _createElementBlock("dd", _hoisted_19, [
                _createVNode(_component_router_link, {
                  to: { name: 'Search', hash: '#' + field.name + '-field-group' },
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate }) => [
                    _createElementVNode("a", {
                      class: "govuk-link",
                      href: href,
                      onClick: navigate
                    }, [
                      _hoisted_21,
                      _createElementVNode("span", _hoisted_22, _toDisplayString(field.label), 1)
                    ], 8, _hoisted_20)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            : (_openBlock(), _createElementBlock("dd", _hoisted_23, [
                _createElementVNode("a", {
                  class: "govuk-link",
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.prevYear(field, _ctx.stageData)), ["prevent"])
                }, [
                  _hoisted_25,
                  _createElementVNode("span", _hoisted_26, _toDisplayString(field.label), 1)
                ], 8, _hoisted_24),
                _hoisted_27,
                _createElementVNode("a", {
                  class: "govuk-link",
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.nextYear(field, _ctx.stageData)), ["prevent"])
                }, [
                  _hoisted_29,
                  _createElementVNode("span", _hoisted_30, _toDisplayString(field.label), 1)
                ], 8, _hoisted_28)
              ]))
        ], 512)), [
          [_vShow, _ctx.showSummaryField(field, _ctx.stageData)]
        ])
      }), 128))
    ]),
    _hoisted_31,
    _hoisted_32,
    (_ctx.data.entries)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("table", _hoisted_35, [
              _createElementVNode("caption", _hoisted_36, _toDisplayString(_ctx.numberOfResultsText), 1),
              _createElementVNode("thead", _hoisted_37, [
                _createElementVNode("tr", _hoisted_38, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, name) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: name,
                      scope: "col",
                      class: "govuk-table__header",
                      "aria-sort": (_ctx.sortColumn === name ? _ctx.sortDirection : 'none')
                    }, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.sortBy(name, 'ascending', column.label)),
                        type: "button"
                      }, _toDisplayString(column.label), 9, _hoisted_40)
                    ], 8, _hoisted_39))
                  }), 128)),
                  _hoisted_41
                ])
              ]),
              _createElementVNode("tbody", _hoisted_42, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.entries, (entry, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "govuk-table__row",
                    key: index
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, name) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: name,
                        class: "govuk-table__cell"
                      }, _toDisplayString(_ctx.getFormattedColumnValue(entry.properties[name], column.type)), 1))
                    }), 128)),
                    _createElementVNode("td", _hoisted_43, [
                      (_ctx.isInBasket(entry.uid))
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "govuk-link",
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.removeFromBasket(index)), ["prevent"])
                          }, " Remove from basket ", 8, _hoisted_44))
                        : (entry.state !== 'onHold')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "govuk-link",
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.prepareForBasket(index)), ["prevent"])
                            }, " Add to basket ", 8, _hoisted_45))
                          : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.sortStatusMessage), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.numberOfPages > 1)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_47, [
          _hoisted_48,
          _createElementVNode("ul", _hoisted_49, [
            _createElementVNode("li", _hoisted_50, [
              (!_ctx.isFirstPage)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "moj-pagination__link",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
                  }, _hoisted_53))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationPages, (page) => {
              return (_openBlock(), _createElementBlock("li", {
                key: page,
                onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"]),
                class: _normalizeClass({ 'moj-pagination__item': true, 'moj-pagination__item--active': _ctx.currentPageNumber === page })
              }, [
                (_ctx.currentPageNumber !== page)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_55, _toDisplayString(page), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(page), 1))
              ], 10, _hoisted_54))
            }), 128)),
            _createElementVNode("li", _hoisted_57, [
              (!_ctx.isLastPage)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "moj-pagination__link",
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
                  }, _hoisted_60))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("p", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("b", null, _toDisplayString(_ctx.data.currentPageOffset), 1),
            _hoisted_63,
            _createElementVNode("b", null, _toDisplayString(_ctx.data.currentPageOffset + _ctx.data.currentPageSize), 1),
            _hoisted_64,
            _createElementVNode("b", null, _toDisplayString(_ctx.numberOfResults), 1),
            _hoisted_65
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_66,
    _hoisted_67,
    _hoisted_68,
    (_ctx.dataCal.entries)
      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
          _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.numberOfResultsTextCal), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataCal.entries, (entry) => {
            return (_openBlock(), _createElementBlock("div", {
              key: entry.properties['file:content'].name
            }, [
              _createElementVNode("a", {
                class: "govuk-link",
                href: "#",
                onClick: _withModifiers(($event: any) => (_ctx.viewImage(entry)), ["prevent"])
              }, " Click to Open Image and Order Document Form ", 8, _hoisted_71),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("a", {
                    class: "pdf-link",
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.viewImage(entry)), ["prevent"])
                  }, [
                    _createVNode(_component_pdf, {
                      src: _ctx.getImageUrl,
                      scale: _ctx.pdfScale,
                      resize: _ctx.pdfResizeNormal,
                      style: {"width":"100%"}
                    }, null, 8, ["src", "scale", "resize"])
                  ], 8, _hoisted_74)
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.dataCal.numberOfPages > 1)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_75, [
          _hoisted_76,
          _createElementVNode("ul", _hoisted_77, [
            _createElementVNode("li", _hoisted_78, [
              (!_ctx.isFirstPageCal)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "moj-pagination__link",
                    href: "#",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPageCal && _ctx.prevPageCal(...args)), ["prevent"]))
                  }, _hoisted_81))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationPagesCal, (page) => {
              return (_openBlock(), _createElementBlock("li", {
                key: page,
                onClick: _withModifiers(($event: any) => (_ctx.goToPageCal(page)), ["prevent"]),
                class: _normalizeClass({ 'moj-pagination__item': true, 'moj-pagination__item--active': _ctx.currentPageNumberCal === page })
              }, [
                (_ctx.currentPageNumberCal !== page)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_83, _toDisplayString(page), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(page), 1))
              ], 10, _hoisted_82))
            }), 128)),
            _createElementVNode("li", _hoisted_85, [
              (!_ctx.isLastPageCal)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "moj-pagination__link",
                    href: "#",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPageCal && _ctx.nextPageCal(...args)), ["prevent"]))
                  }, _hoisted_88))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("p", _hoisted_89, [
            _hoisted_90,
            _createElementVNode("b", null, _toDisplayString(_ctx.dataCal.currentPageOffset), 1),
            _hoisted_91,
            _createElementVNode("b", null, _toDisplayString(_ctx.dataCal.currentPageOffset + _ctx.dataCal.currentPageSize), 1),
            _hoisted_92,
            _createElementVNode("b", null, _toDisplayString(_ctx.numberOfResultsCal), 1),
            _hoisted_93
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_94,
    _createVNode(_component_router_link, {
      to: { name: 'Home', params: { clearSearch: 'true' } },
      custom: ""
    }, {
      default: _withCtx(({ href, navigate }) => [
        _createElementVNode("a", {
          href: href,
          onClick: navigate,
          role: "button",
          draggable: "false",
          class: "govuk-button",
          "data-module": "govuk-button"
        }, " New Search ", 8, _hoisted_95)
      ]),
      _: 1
    }),
    (_ctx.pdfFullscreen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("button", {
                class: "govuk-button",
                href: "#",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.viewImage()), ["prevent"]))
              }, " Back "),
              (_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "govuk-button toggle-form",
                    href: "#",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.toggleForm()), ["prevent"]))
                  }, _toDisplayString(_ctx.pdfShowFormText), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.pdfShowForm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                _createElementVNode("div", null, [
                  _hoisted_100,
                  _createVNode(_component_Form, {
                    fieldsets: _ctx.fieldsets,
                    fields: _ctx.fields,
                    buttons: _ctx.buttons,
                    onFormHasPassedValidation: _ctx.saveFormData
                  }, null, 8, ["fieldsets", "fields", "buttons", "onFormHasPassedValidation"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.data.entries)
            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataCal.entries, (entry) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: entry.properties['file:content'].name
                  }, [
                    _createVNode(_component_pdf, {
                      src: _ctx.getImageUrl,
                      scale: _ctx.pdfScale,
                      resize: _ctx.pdfResizeLarge,
                      style: {"width":"100%"}
                    }, null, 8, ["src", "scale", "resize"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("div", _hoisted_103, [
              (!_ctx.isMobile && !_ctx.isFirstPageCal)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "govuk-button",
                    href: "#",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.prevPageCal && _ctx.prevPageCal(...args)))
                  }, " Previous Page "))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "govuk-button",
                href: "#",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pdfScale -= _ctx.pdfScale > 0.2 ? 0.1 : 0))
              }, " Zoom - "),
              _createElementVNode("span", null, _toDisplayString(_ctx.pdfFormattedZoom) + " % ", 1),
              _createElementVNode("button", {
                class: "govuk-button",
                href: "#",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pdfScale += _ctx.pdfScale < 2 ? 0.1 : 0))
              }, " Zoom + "),
              (!_ctx.isMobile && !_ctx.isLastPageCal)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "govuk-button",
                    href: "#",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.nextPageCal && _ctx.nextPageCal(...args)))
                  }, " Next Page "))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                  (!_ctx.isFirstPageCal)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "govuk-button",
                        href: "#",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.prevPageCal && _ctx.prevPageCal(...args)))
                      }, " Previous Page "))
                    : _createCommentVNode("", true),
                  (!_ctx.isLastPageCal)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "govuk-button",
                        href: "#",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.nextPageCal && _ctx.nextPageCal(...args)))
                      }, " Next Page "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}